import { Stack, Typography } from '@mui/material';

import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Banner from 'common/components/Banner/Banner';
import { ACTION_PLAN_TAB_CONSTANTS } from 'common/constants/TaxonomyConstants';
import { HorizonScanningPageTitle } from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setSelectedTabValue } from 'common/store/reducer/mappingDetailsReducer';

import UpdatesTable from './components/UpdatesTable/UpdatesTable';
import StatusBar from './StatusBar';

import styles from './HorizonScanning.module.scss';

const { TAB_MAPPING } = ACTION_PLAN_TAB_CONSTANTS;

const HorizonScanningPage = () => {
	const dispatch = useDispatch();
	const filter = useSelector(
		(state: RootState) => state.common.multiSelectProductFilterData,
	);
	const searchText = useSelector(
		(state: RootState) => state.common.horizonScanningSearchText,
	);
	useEffect(() => {
		dispatch(setSelectedTabValue(TAB_MAPPING));
	}, []);
	const { title, body } = HorizonScanningPageTitle;
	return (
		<Stack>
			<Banner>
				<Stack p={2} className={styles['horizon-header-wrapper']}>
					<Typography className={styles['horizon-banner-heading']}>
						{title}
					</Typography>
					<Typography mt={0} className={styles['horizon-banner-content']}>
						{body}
					</Typography>
				</Stack>
			</Banner>
			<StatusBar searchText={searchText} filter={filter} />
			<UpdatesTable />
		</Stack>
	);
};

export default HorizonScanningPage;
